import { create } from "zustand";
import { MOBILE_BREAKPOINT } from "../constants";

type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: {
    platform?: string;
  };
};

type DeviceState = {
  isMobile: boolean;
  isMacDesktop: boolean;
  setIsMobile: (isMobile: boolean) => void;
};

const getInitialIsMobile = () =>
  typeof window !== "undefined"
    ? window.innerWidth <= MOBILE_BREAKPOINT
    : false;

export const isMacDesktopDevice = () => {
  if (typeof navigator === "undefined") return false;

  const { userAgentData, platform, userAgent, maxTouchPoints } =
    navigator as NavigatorWithUserAgentData;
  const detectedPlatform = userAgentData?.platform ?? platform ?? "";
  const detectedUserAgent = userAgent ?? "";
  const isAppleMobile = /iPhone|iPad|iPod/i.test(detectedUserAgent);
  const isIPadDesktopMode =
    detectedPlatform === "MacIntel" && maxTouchPoints > 1;

  return (
    /macOS|Mac/i.test(detectedPlatform) &&
    !isAppleMobile &&
    !isIPadDesktopMode
  );
};

export const useDeviceStore = create<DeviceState>((set) => ({
  isMobile: getInitialIsMobile(),
  isMacDesktop: isMacDesktopDevice(),
  setIsMobile: (isMobile) =>
    set((state) => (state.isMobile === isMobile ? state : { isMobile })),
}));
